export default __webpack_public_path__ + "8d593cfaa96238d5e2f8af9e11cc5a68.woff";